import './styles.css';

import { Button, FlatButton } from 'bz-core-controls';

import Colours from 'bz-core-controls/styles/colours';
import history from 'bz-utilities/modules/networking/history/rr4';
import React from 'react';

export interface IProps {
  className: string;
  cancelLabel: string;
  okLabel: string;
  errors: string[];
  title: string;
  preventSaveIfErrored?: boolean;

  onOk: (e: React.MouseEvent<any>) => void;
  onCancel: (e: React.MouseEvent<any>) => void;
}

const clinicalCasePathPattern = /(\/clinical\/cases\/\d+(?:\?appointmentId=\d+)?)/g;
const clinicalCasePathOnlyPattern = /^\/clinical\/cases\/\d+(?:\?appointmentId=\d+)?$/;

function renderMessageWithCaseLinks(message: string) {
  const parts = message.split(clinicalCasePathPattern);

  if (parts.length === 1) {
    return message;
  }

  return parts.map((part, index) => {
    if (clinicalCasePathOnlyPattern.test(part)) {
      return (
        <a
          key={index}
          href={part}
          onClick={(event) => {
            event.preventDefault();
            history.push(part);
          }}
        >
          {part}
        </a>
      );
    }

    return part;
  });
}

class ErrorPanel extends React.Component<IProps> {
  static readonly defaultProps: Partial<IProps> = {
    title: 'Warning',
    okLabel: 'Yes',
    cancelLabel: 'No'
  };

  render() {
    const { className } = this;
    const { errors, title, preventSaveIfErrored } = this.props;
    const errorsList = errors.map((err, i) => {
      return <li key={i}>{renderMessageWithCaseLinks(err)}</li>;
    });
    if (!!process.env.isClick) {
      return (
        <div className={`${className} root`}>
          <h3 className={`${className} title`}>{title}</h3>
          <div className={`${className} content`}>
            <ul>{errorsList}</ul>
          </div>
        </div>
      );
    }

    let buttons;
    if (preventSaveIfErrored) {
      buttons = <FlatButton onClick={this.props.onCancel}>OK</FlatButton>;
    } else {
      buttons = (
        <>
          <FlatButton onClick={this.props.onCancel}>{this.props.cancelLabel}</FlatButton>
          <Button onClick={this.props.onOk} backgroundColor={Colours.red900} primary={true}>
            {this.props.okLabel}
          </Button>
        </>
      );
    }
    return (
      <div className={`${className} root`}>
        <h3 className={`${className} title`}>{title}</h3>
        <div className={`${className} content`}>
          <ul>{errorsList}</ul>
          {buttons}
        </div>
      </div>
    );
  }

  get className(): string {
    const { className } = this.props;
    const classNames = ['bz-controls bz-modal errors-panel'];

    if (!!className) {
      classNames.push(className);
    }

    return classNames.join(' ');
  }
}

export default ErrorPanel;
